var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"user-auth","fluid":"","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('base-material-card',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('div',{staticClass:"text-h3 font-weight-light"},[_vm._v(" Authenticating ... ")])]},proxy:true}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }